var accordianSecColContent = (function () {
  return {
    init: init,
  };

  function init() {
    var faqToggle = document.getElementsByClassName("tc-accordian-container"),
      faqToggleActive = document.querySelectorAll(
        ".tc-accordian-container.activeToggle"
      );

    if (faqToggle.length) {
      /**
       * Apply FAQ inside Links tabIndex -1 except first element
       */
      var allFAQLinks = document.querySelectorAll(".tc-accordian-wrapper a");

      for (var j = 0; j < allFAQLinks.length; j++) {
        allFAQLinks[j].tabIndex = -1;
      }

      for (var l = 0; l < faqToggleActive.length; l++) {
        var faqToggleActiveDesc = faqToggleActive[l].querySelector(".tc-accordian-desc");
        faqToggleActiveDesc.style.maxHeight =
          "inherit";
        var firstELementLink = faqToggleActive[l].querySelectorAll("a");
        for (var k = 0; k < firstELementLink.length; k++) {
          firstELementLink[k].tabIndex = 0;
        }
        var childElem =
          faqToggleActive[l].parentNode.querySelectorAll(".tc-accordian-btn");
        for (var q = 0; q < childElem.length; q++) {
          childElem[q].setAttribute("data-group", "tc-accordian-group-" + l);
        }

        //check for second col update content
        var faqAnswerSecCol = faqToggleActiveDesc.querySelector(".tc-accordian--second-col-content"),
        twoColParentRows = faqToggleActive[l].closest(".col-sec__rows");

        if (twoColParentRows) {
          var twoColParentCol = twoColParentRows.querySelector(".col-sec__img");
          if (twoColParentCol) {
            twoColParentCol.innerHTML = faqAnswerSecCol.innerHTML;
          }
        }
      }

      /**
       * Making First Element Active bydefault
       */

      for (var i = 0; i < faqToggle.length; i++) {
        faqToggle[i].setAttribute("data-index", i);
        faqToggle[i].children[0]
          .querySelector("button")
          .addEventListener("click", faqToggleClick);
      }

      //arrow up and down
      var accordianMainWrapper = document.querySelectorAll(
        ".tc-accordian-wrapper"
      );
      for (var m = 0; m < accordianMainWrapper.length; m++) {
        accordianMainWrapper[m].addEventListener("keydown", function (event) {
          var target = event.target,
            key = event.which.toString(),
            triggers = Array.prototype.slice.call(
              this.querySelectorAll(".tc-accordian-btn")
            ),
            ctrlModifier = event.ctrlKey && key.match(/33|34/); // 33 = Page Up, 34 = Page Down

          // Is this coming from an accordion header?
          if (target.classList.contains("tc-accordian-btn")) {
            // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
            // 38 = Up, 40 = Down
            if (key.match(/38|40/) || ctrlModifier) {
              var index = triggers.indexOf(target),
                direction = key.match(/34|40/) ? 1 : -1,
                length = triggers.length,
                newIndex = (index + length + direction) % length;

              triggers[newIndex].focus();

              event.preventDefault();
            } else if (key.match(/35|36/)) {
              // 35 = End, 36 = Home keyboard operations
              switch (key) {
                // Go to first accordion
                case "36":
                  triggers[0].focus();
                  break;
                // Go to last accordion
                case "35":
                  triggers[triggers.length - 1].focus();
                  break;
              }
              event.preventDefault();
            }
          }
        });
      }

      function faqToggleClick() {
        var that = this,
          currentElemParent = that.parentNode.parentNode,
          dataIndex = currentElemParent.getAttribute("data-index"),
          faqAnswer = currentElemParent.children[1],
          faqAnswerSecCol = faqAnswer.querySelector(".tc-accordian--second-col-content"),
          twoColParentRows = that.closest(".col-sec__rows"),
          allFAQLinks = that
            .closest(".tc-accordian-wrapper")
            .querySelectorAll("a"),
          activeElementLink = currentElemParent.querySelectorAll("a"),
          getGroupName = that.getAttribute("data-group");

        //tabindex -1 assign to inside all FAQ accordion
        for (var j = 0; j < allFAQLinks.length; j++) {
          allFAQLinks[j].tabIndex = -1;
        }

        //Update Content

        for (j = 0; j < faqToggle.length; j++) {
          if (j != dataIndex) {
            if (
              getGroupName ===
              faqToggle[j]
                .querySelector(".tc-accordian-btn")
                .getAttribute("data-group")
            ) {
              // check FAQ for that group section
              faqToggle[j].classList.remove("activeToggle");
              faqToggle[j].children[0].classList.remove("active");
              faqToggle[j].children[1].style.maxHeight = 0;
              faqToggle[j]
                .querySelector(".tc-accordian-btn")
                .setAttribute("aria-expanded", false);
            }
          } else {
            /**
             * Adding active class to the clicked element.
             */
            
            if (faqAnswerSecCol && !currentElemParent.classList.contains("activeToggle")) {
              var twoColParentCol = twoColParentRows.querySelector(".col-sec__img");
              if (twoColParentCol) {
                twoColParentCol.innerHTML = faqAnswerSecCol.innerHTML;
              }
            }

            currentElemParent.classList.toggle("activeToggle");
            currentElemParent.classList.add("active-click");
            currentElemParent.children[0].classList.toggle("active");
            that.setAttribute("aria-expanded", true);

            for (var k = 0; k < activeElementLink.length; k++) {
              if (currentElemParent.classList.contains("activeToggle")) {
                activeElementLink[k].tabIndex = 0;
              } else {
                activeElementLink[k].tabIndex = -1;
              }
            }

            /**
             * Adding height to the Faq Answer
             */
            if (!currentElemParent.classList.contains("activeToggle")) {
              faqAnswer.style.maxHeight = null;
              that.setAttribute("aria-expanded", false);
            } else {
              faqAnswer.style.maxHeight = faqAnswer.scrollHeight + "px";
            }
          }
        }

        //show images from lazy load
        lazyLoading.show();
      }
    }
  }
})();

accordianSecColContent.init();
